import React from 'react';
import _ from 'lodash'
import { ContentCard } from './ContentCard';

/**
 *  Content List: Shows a list of content cards in a horizontally scrolling section
 *  Props:  history, title, dummy (if true renders a dummy list instead), contents
 */

const ContentList = ({title, dummy=false, contents, history}) => {
  
  // function that redirects to the content viewer page while passing the id of the content as url params
  const redirectTo = (link) => {
    window.open(link);
  }

  // if the render dummy list is off then show actual list
  if(!dummy) {
    return(
      <div style={styles.mainContainer}> 
        {title && <h1>{title}</h1>}
        <div>
          {
            contents!==undefined && contents?.length !== 0 ?
            contents.map( content => (
              <ContentCard 
                key={content.id}
                image={content.path}
                title={content.title}
                onClick={()=> redirectTo(content.link)}
                tags={content.tags}
              />
            ))
            :
            <ContentCard 
              key={1}
              image='https://react.semantic-ui.com/images/wireframe/image.png'
              title="No content found"
            />
          }
        </div>
      </div> 
    )
  }
  // dummy is set to true, so render a dummy content list as placeholder
  else {
    return (  
      <div style={styles.mainContainer}> 
        {title && <h1>{title}</h1>}
        <div >
          {
            _.times(16, (i) => (
            <ContentCard 
              key={i}
              image='https://react.semantic-ui.com/images/wireframe/image.png'
              title={`Episode 0${i+1}: Episode Name`}
              onClick={()=> console.log('clicked')}
            />
          ))}
        </div>
      </div>
    );
  }
}

const styles = {
  mainContainer: {
    // marginTop: '4em',
    marginBottom: '4em',
  },
  verticalScrollSection: {
    marginTop: '2em',
    marginBottom: '2em',
    overflowX: 'auto',
    whiteSpace: 'nowrap',
    display: 'flex',
    flexDirection: 'row',
  }
}

export {ContentList};
